import { LocalAuthority } from "../../model"

export function getCodeName(localAuthority: LocalAuthority): string {
	return `${localAuthority.code} - ${localAuthority.name}`
}

export function getLocalAuthority(
	localAuthorities: LocalAuthority[],
	id: number
): LocalAuthority | null {
	return localAuthorities.find(la => la.id === id) || null
}

/**
 * Retourne une chaine sous la forme "<code> - <name>" si la collectivité
 * existe, sinon "Indéterminée".
 * @param chapter
 */
export function titlize(localAuthority: LocalAuthority): string {
	return localAuthority
	? `${localAuthority.code} - ${localAuthority.name}` : "Indéterminée"
}



// WEBPACK FOOTER //
// ./src/domain/sfp/local-authority-domain.ts